import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import {CouponCode, CouponCodeUpdateInput} from '../__generated__/resolvers-types';
import validateRequestError from '../util/error/validateRequestError';

export const UPDATE_COUPON_CODE_MUTATION = gql`
  mutation UpdateCouponCode($id: String!, $input: CouponCodeUpdateInput!) {
    updateCouponCode(id: $id, input: $input) {
      id
      name
      status
      maxUses
      usedCount
      createdAt
      expiryDate
      durationDays
      couponRole
      createdBy
    }
  }
`;

export const useUpdateCouponCode = () => {
  const [updateCouponCode] = useMutation<{updateCouponCode: CouponCode}>(UPDATE_COUPON_CODE_MUTATION);

  const updateCoupon = async (id: string, input: CouponCodeUpdateInput) => {
    const result = await validateRequestError(updateCouponCode({variables: {id, input}}));
    return result?.updateCouponCode;
  };

  return updateCoupon;
};
